var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trophy_filled_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 27.4 24",
    style: {
      enableBackground: "new 0 0 27.4 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "trophy_filled_svg__Icon_metro-trophy",
    d: "M22.3,3.4V0H5.1v3.4H0v3.4C0,9.7,2.3,12,5.2,12c0.5,0,1-0.1,1.5-0.2c1.3,1.8,3.2,3.1,5.3,3.5v5.3 h-1.7c-1.9,0-3.4,1.5-3.4,3.4l0,0h13.7c0-1.9-1.5-3.4-3.4-3.4h-1.7v-5.3c2.2-0.4,4.1-1.7,5.3-3.5c2.7,0.9,5.6-0.7,6.5-3.4 c0.2-0.5,0.2-1,0.2-1.5V3.4H22.3z M5.1,10C3.4,10,2,8.6,2,6.9V5.1h3.1v1.7c0,1,0.2,2.1,0.6,3.1C5.5,9.9,5.3,10,5.1,10L5.1,10z  M25.4,6.9c0,1.7-1.4,3.1-3.1,3.1c-0.2,0-0.4,0-0.6-0.1c0.4-1,0.6-2,0.6-3.1V5.1h3.1L25.4,6.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyFilled);
export default __webpack_public_path__ + "static/media/trophy_filled.9901572fe177fd8071032d01e55f850e.svg";
export { ForwardRef as ReactComponent };